<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div v-if="success" class="card success-card">
          <div class="card-body green">You successfully registered a new device!</div>
        </div>
        <b-alert variant="danger"
          dismissible
          :show="failure"
          @dismissed="failure=false">
          {{message}}
        </b-alert>
      </b-col>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Register Device</strong>
          </div>
          <b-form @submit.prevent="registerDevice">
          <b-form-group
            label="Company"
            label-for="basicSelect">
            <b-form-select id="basicSelect"
              v-model="companyId"
              name="company_id"
              v-validate="'required'"
              :plain="true"
              :options="companies"
              value="Please select"
              :change="companyChanged()"
              :class="{'has-error': errors.has('company_id')}"
            >
            </b-form-select>
            <span class="red">{{ errors.first('company_id') }}</span>
          </b-form-group>
          <b-form-group
            description="The device name displayed publicy to the user on the mobile app."
            label="Device Name">
            <b-form-input
              v-model="name"
              type="text"
              v-validate="'required'"
              placeholder="Enter device name"
              name="device_name"
              :class="{'has-error': errors.has('device_name')}"
            ></b-form-input>
            <span class="red">{{ errors.first('device_name') }}</span>
          </b-form-group>
          <b-form-group
            description="The unique internal device id."
            label="Device ID">
            <b-form-input
              v-model="id"
              type="text"
              v-validate="'required'"
              placeholder="Enter device id"
              name="device_id"
              autocomplete="off"
              :class="{'has-error': errors.has('device_id')}"
            ></b-form-input>
            <span class="red">{{ errors.first('device_id') }}</span>
          </b-form-group>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="streetAddress">Street Address</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="streetAddress"
                  placeholder="Enter street address"
                  name="street_address"
                  :class="{'has-error': errors.has('street_address')}"
                ></b-form-input>
                <span class="red">{{ errors.first('street_address') }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="city">City</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="city"
                  id="city"
                  placeholder="Enter your city"
                  name="city"
                  :class="{'has-error': errors.has('city')}"
                ></b-form-input>
                <span class="red">{{ errors.first('city') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label="Province / State"
                label-for="selectProvinceState">
                <b-form-select id="selectProvinceState"
                  v-model="province"
                  v-validate="'required'"
                  :plain="true"
                  :options="stateProvince"
                  value="Please select"
                  name="state_province"
                  :class="{'has-error': errors.has('state_province')}"
                >
                </b-form-select>
                <span class="red">{{ errors.first('state_province') }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="postal-code">Postal / Zip Code</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="postalCode"
                  id="postal-code"
                  placeholder="Postal / Zip Code"
                  name="postal_code"
                  :class="{'has-error': errors.has('postal_code')}"
                ></b-form-input>
                <span class="red">{{ errors.first('postal_code') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="form-actions">
            <b-button type="submit" name="submit" variant="primary">Submit</b-button>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import stateProvince from '../../stateProvince'

export default {
  name: 'RegisterDevice',
  data () {
    return {
      admin: {},
      companies: [],
      id: '',
      name: '',
      companyId: 0,
      streetAddress: '',
      city: '',
      postalCode: '',
      province: '',
      success: false,
      failure: false,
      message: '',
      stateProvince
    }
  },
  methods: {
    /**
     * Method executed whenever a different company is selected from companies dropdown. This auto populates all fields with company information for ease-of-use.
     */
    companyChanged: function () {
      let company = ''

      for (let i = 0; i < this.companies.length; i++) {
        company = this.companies[i]

        if (this.companyId === company.value) {
          this.streetAddress = company.street_address
          this.city = company.city
          this.province = company.province
          this.postalCode = company.postal_code
          return
        }
      }
    },
    /**
     * Gets all companies registered under this organization in order to populate the companies select dropdown field.
     */
    getCompanies: function () {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/companies`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let data = response.data.data
          let companies = []

          for (let i = 0; i < data.length; i++) {
            companies.push({
              street_address: data[i]['street_address'],
              city: data[i]['city'],
              postal_code: data[i]['postal_code'],
              province: data[i]['province'],
              value: data[i]['company_id'],
              text: data[i]['name']
            })

            // select first option in company dropdown
            if (i === 0) {
              self.companyId = response.data.data[i]['company_id']
            }
          }

          self.companies = companies
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /**
     * Submits the form information to the backend API once submit button is pressed. The information is passed through a validator to make sure they meet the required details.
     */
    registerDevice: function () {
      let self = this
      self.success = false
      self.failure = false

      const { id, name, companyId, streetAddress, city, postalCode, province } = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.post(`${process.env.VUE_APP_API_URL}api/devices`, {
            device_name: name,
            name: id,
            company_id: companyId,
            street_address: streetAddress,
            city,
            postal_code: postalCode,
            province
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function () {
              self.success = true
              window.scrollTo(0, 0)
            })
            .catch(function (error) {
              // error for if id already exists
              if (error.response.data.error.detail.includes('already exists')) {
                self.failure = true
                self.message = 'Device ID already exists in the system.'
                window.scrollTo(0, 0)
              }
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    }
  },
  mounted () {
    this.getCompanies()
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
